import React from 'react';
import { HashRouter as Router, Routes, Route } from "react-router-dom";
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import { AuthProvider } from './components/auth/AuthContext';
import HomePage from './pages/HomePage';
import QuoteEditor from './pages/QuoteEditor';
import AgentChatDashboard from './pages/AgentChatDashboard';
import AdminDashboard from './pages/AdminDashboard';
import ProtectedRoute from './components/auth/ProtectedRoute';
import LoginPage from './components/LoginPage';
import RedirectToMainSite from './components/RedirectToMainSite';

import "@ag-grid-community/styles/ag-grid.css";
import "@ag-grid-community/styles/ag-theme-alpine.css";

function App() {
    // Interní aplikace pro agenty K-Drives
    // Zákaznický portál běží na Vercelu a volá sem jen API (portal_services)
    return (
        <AuthProvider>
            <Router> 
                <ToastContainer
                    position="top-right"
                    autoClose={5000} 
                    hideProgressBar={false}
                    newestOnTop={false}
                    closeOnClick
                    rtl={false}
                    pauseOnFocusLoss
                    draggable
                    pauseOnHover
                    theme="colored"
                />
                <Routes>
                    <Route path="/login" element={ <LoginPage /> } />
                    <Route path="/" element={ <ProtectedRoute> <HomePage /> </ProtectedRoute> } />
                    <Route path="/chats" element={ <ProtectedRoute> <AgentChatDashboard /> </ProtectedRoute> } />
                    <Route path="/admin" element={ <ProtectedRoute> <AdminDashboard /> </ProtectedRoute> } />
                    <Route path="/quote/:quoteId" element={ <ProtectedRoute> <QuoteEditor /> </ProtectedRoute> } />
                    <Route path="*" element={ <RedirectToMainSite /> } />
                </Routes>
            </Router>
        </AuthProvider>
    );
}

export default App;